module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.products.length > 0) ? _c('div', {
    staticClass: "new_soproni_small_area"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "soproni_small",
    staticStyle: {
      "padding-top": "0px",
      "padding-bottom": "30px"
    }
  }, [_c('div', {
    staticClass: "row my-row"
  }, [(_vm.products != null) ? [_c('div', _vm._l((_vm.products), function(p) {
    return _c('product-list-view', {
      key: p.id,
      attrs: {
        "product": p
      }
    })
  }))] : _vm._e()], 2)])])])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "section_title_box"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "section_title"
  }, [_c('div', {
    staticClass: "section_title_cont text-left"
  }, [_c('h3', [_vm._v("AJÁNLOTT TERMÉKEK")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2f9e256a","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/main/components/pages/list/Promoted.vue
// module id = 109
// module chunks = 0 1 2